export const DATE_RANGE = Object.freeze({
  null: "Today",
  yesterday: "Yesterday",
  last7days: "Last 7 Days",
  last30days: "Last 30 Days",
  custom: "Custom",
});

export default {};
